import React from 'react'
import Icon from 'components/Icon'
import ytIcon from 'assets/images/icons/y.png'
import gIcon from 'assets/images/icons/g.png'
import fIcon from 'assets/images/icons/f.png'
import tIcon from 'assets/images/icons/t.png'
import iIcon from 'assets/images/icons/i.png'
import lIcon from 'assets/images/icons/l.png'
import inst from 'assets/images/icons/inst.png'

function IconLabel({ icon, label, link}: any) {
    return (
        <div className="d-flex align-items-center m-2 cursor-pointer" onClick={() => {link && window.open(link, "_blank") }}>
            {icon && <Icon name={icon} />}
            {label && <div className="ms-2" >{label}</div>}
        </div>
    )
}

export default function Footer() {
    return (
        <div className="footer d-flex justify-content-between align-items-center m-2 flex-wrap">
            <div className="d-flex flex-wrap">
                <IconLabel icon="envelope-o" label={'awards@propertyguru.com'}/>
                <IconLabel icon="phone" label={'(+66) 2204 9599'}/>
                <IconLabel label={'FAQ'} link="https://www.asiapropertyawards.com/en/frequently-asked-questions/"/>
                <IconLabel label={'Terms & Conditions'} link="https://www.asiapropertyawards.com/en/terms-conditions/"/>

                <img src={lIcon} width='16' height='16' className="m-2 mt-2 cursor-pointer" onClick={() => window.open("https://www.flickr.com/photos/71217749@N02/albums")}/>
                <img src={inst} width='16' height='16' className="m-2 cursor-pointer" onClick={() => window.open("https://www.instagram.com/asiapropertyawards/")}/>
                <img src={ytIcon} width='16' height='16' className="m-2 cursor-pointer" onClick={() => window.open("https://www.youtube.com/channel/UCCMEFMU-KW5dEKfb5dPTL9Q")}/>  
                <img src={fIcon} width='16' height='16' className="m-2 cursor-pointer" onClick={() => window.open("https://www.facebook.com/asiapropertyawards")} />
                <img src={iIcon} width='16' height='16' className="m-2 cursor-pointer" onClick={() => window.open("https://www.linkedin.com/showcase/asia-property-awards")}/>
                <img src={tIcon} width='16' height='16' className="m-2 cursor-pointer" onClick={() => window.open("https://twitter.com/AsiaPropAwards")}/>

            </div>

            <div className="me-3">
                © {new Date().getFullYear()} PropertyGuru Pte. Ltd. "Asia Property Awards" is a registered trademark
            </div>
        </div>
    )
}
